import React from "react";
import { Appointments } from "@devexpress/dx-react-scheduler-material-ui";
import capitalize from "lodash/capitalize";

import { Box } from "@mui/material";

import { errorRed, white } from "globals/design-system/colors";
import { DriverScheduleSettingScheduleTypeEnum } from "types";
import { formatTimeRange } from "globals/utils/dateFormatters";
import { SyncIcon } from "globals/design-system/icons";

const { Available } = DriverScheduleSettingScheduleTypeEnum;

// Customize appointment content component for Scheduler
const AppointmentContent = ({ data, ...restProps }: any) => {
  const timeRange = formatTimeRange(data.startDate, data.endDate);

  return (
    <Appointments.AppointmentContent {...restProps} data={data}>
      <Box
        sx={{
          color: data.type === Available ? white : errorRed,
          padding: "4px",
        }}
      >
        <Box display="flex" alignItems="center" gap={0.3}>
          {data.daysToRepeat ? (
            <Box mt={0.4}>
              <SyncIcon size="xs" color={white} />
            </Box>
          ) : null}
          <Box style={{ fontWeight: 600 }}>{capitalize(data.type)}</Box>
        </Box>

        <Box style={{ fontSize: "0.9em", marginTop: "2px" }}>{timeRange}</Box>
      </Box>
    </Appointments.AppointmentContent>
  );
};

export default AppointmentContent;
